{
  "title": "Assistance",
  "subtitle": "Créez et suivez vos demandes d'assistance.",
  "newTicket": "Nouveau ticket",
  "newReply": "Nouvelle réponse",
  "quick": {
    "heading": "Actions rapides",
    "trackOrder": {
      "label": "Suivre la commande",
      "caption": "Vérifiez le statut ou la position d'une commande.",
      "subject": "Suivre ma commande",
      "description": "Je souhaite vérifier le statut et la position actuelle de ma commande. Numéro de commande : "
    },
    "startReturn": {
      "label": "Demander un retour",
      "caption": "Demandez un retour ou un remboursement pour une commande.",
      "subject": "Demander un retour",
      "description": "Je souhaite demander un retour ou un remboursement pour ma commande. Numéro de commande : \nMotif : "
    },
    "orderIssues": {
      "label": "Problème de commande",
      "caption": "Signalez un problème de produit ou de livraison.",
      "subject": "Problème avec ma commande",
      "description": "Je rencontre un problème avec un produit de ma commande. Numéro de commande : \nCe qui ne va pas : "
    },
    "paymentHelp": {
      "label": "Aide au paiement",
      "caption": "Obtenez de l'aide pour la facturation ou les paiements.",
      "subject": "Aide au paiement / facturation",
      "description": "J'ai besoin d'aide concernant un paiement ou une facturation. Veuillez décrire votre question : "
    }
  },
  "tabs": {
    "all": "Tous",
    "Open": "Ouvert",
    "InProgress": "En cours",
    "Resolved": "Résolu",
    "Closed": "Fermé"
  },
  "status": {
    "Open": "Ouvert",
    "InProgress": "En cours",
    "Resolved": "Résolu",
    "Closed": "Fermé",
    "Reopened": "Rouvert"
  },
  "category": {
    "Order": "Commande",
    "Billing": "Facturation",
    "Product": "Produit",
    "Account": "Compte"
  },
  "priority": {
    "Critical": "Critique",
    "High": "Élevée",
    "Medium": "Moyenne",
    "Low": "Faible"
  },
  "filters": {
    "issueType": "Type de problème",
    "allTypes": "Tous les types",
    "refresh": "Actualiser"
  },
  "card": {
    "order": "Commande :",
    "replies": "Réponses",
    "updated": "Mis à jour {{time}}"
  },
  "table": {
    "subject": "Sujet",
    "category": "Catégorie",
    "priority": "Priorité",
    "status": "Statut",
    "updated": "Mis à jour",
    "ticketNumber": "N° Ticket"
  },
  "list": {
    "loading": "Chargement…",
    "error": "Impossible de charger la liste des tickets.",
    "empty": "Aucun ticket pour le moment.",
    "searchPlaceholder": "Rechercher par n° de ticket ou sujet..."
  },
  "modal": {
    "title": "Créer un ticket d'assistance",
    "subjectLabel": "Sujet",
    "subjectPlaceholder": "Résumez votre problème",
    "categoryLabel": "Catégorie",
    "priorityLabel": "Priorité",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Décrivez en détail le problème rencontré",
    "cancel": "Annuler",
    "submit": "Créer le ticket",
    "submitting": "Création…",
    "error": "Échec de la création du ticket.",
    "orderLabel": "Commande liée (facultatif)",
    "orderNone": "— Aucune commande —",
    "orderSearchPlaceholder": "Rechercher des commandes…",
    "orderNoResults": "Aucune commande trouvée",
    "orderSelectedCount": "{{count}} commande(s) liée(s)",
    "orderRemove": "Retirer {{order}}"
  },
  "detail": {
    "back": "Liste des tickets",
    "loading": "Chargement…",
    "notFound": "Ticket introuvable.",
    "createdAt": "Créé {{date}}",
    "you": "Vous",
    "agent": "Assistance",
    "closed": "Ticket fermé.",
    "replyPlaceholder": "Saisissez une réponse…",
    "send": "Envoyer",
    "sending": "Envoi…",
    "resolutionTitle": "Résolution",
    "conversation": "Conversation",
    "detailsHeading": "Détails",
    "fieldStatus": "Statut",
    "fieldPriority": "Priorité",
    "fieldCategory": "Catégorie",
    "fieldOrder": "Commande",
    "fieldAssignee": "Assigné à",
    "fieldCreated": "Créé le",
    "fieldUpdated": "Mis à jour",
    "unassigned": "Non assigné",
    "ticketInfo": "Infos du ticket",
    "fieldIssueType": "Type de problème",
    "fieldLastUpdated": "Dernière mise à jour",
    "relatedOrders": "Commandes liées",
    "noRelatedOrders": "Aucune commande liée",
    "activityTimeline": "Chronologie",
    "ticketCreated": "Ticket créé",
    "supportReplied": "Réponse du support",
    "noMessages": "Aucun message pour le moment.",
    "resolvedPrompt": "Le support a marqué ce ticket comme résolu. Êtes-vous satisfait ?",
    "reopenBtn": "Pas satisfait — rouvrir",
    "reopenCommentPlaceholder": "Dites-nous ce qui ne va pas encore (facultatif)",
    "reopenSubmit": "Rouvrir le ticket",
    "reopenCancel": "Annuler",
    "confirmCloseBtn": "Confirmer et fermer",
    "sent": "Envoyé",
    "read": "Lu",
    "viewAll": "Tout afficher ({{count}})",
    "showLess": "Réduire",
    "closeTicket": "Fermer le ticket",
    "download": "Télécharger",
    "moreActions": "Plus d'actions",
    "attachments": "Pièces jointes",
    "composePlaceholder": "Saisissez votre message… (Collez des images avec Ctrl+V)",
    "youReplied": "Vous avez répondu",
    "ticketReopened": "Ticket rouvert",
    "preferredResolution": "Résolution souhaitée : {{value}}"
  },
  "compose": {
    "keyboardHint": "Entrée pour envoyer · Option+Entrée pour une nouvelle ligne",
    "attach": "Joindre un fichier",
    "uploading": "Téléversement…",
    "removeAttachment": "Retirer {{filename}}",
    "linkOrder": "Lier une commande",
    "searchOrder": "Rechercher une commande…",
    "noOrders": "Aucune commande trouvée",
    "uploadFailTitle": "Échec du téléversement",
    "fileTooLarge": "Le fichier dépasse la limite de 10 Mo",
    "fileTypeForbidden": "Ce type de fichier n'est pas autorisé",
    "download": "Télécharger",
    "imageAlt": "Image jointe",
    "attachDisabledHint": "Les pièces jointes ne sont disponibles que lorsque le dispatch est actif"
  },
  "stats": {
    "all": "Tous les tickets",
    "open": "Ouverts",
    "inProgress": "En cours",
    "resolved": "Résolus"
  },
  "resolution": {
    "Reprint": "Réimpression",
    "FullRefund": "Remboursement total",
    "PartialRefund": "Remboursement partiel",
    "StoreCredit": "Avoir boutique",
    "Replacement": "Remplacement",
    "ShippingCredit": "Avoir livraison",
    "NoActionRequired": "Aucune action requise",
    "Escalated": "Escaladé"
  },
  "rating": {
    "prompt": "Comment était notre support ? Notez ce ticket :",
    "starAria": "{{count}} étoiles",
    "commentPlaceholder": "Commentaire (facultatif)...",
    "submit": "Envoyer la note",
    "submitting": "Envoi...",
    "thanks": "Merci pour votre retour !",
    "invite": "Ce ticket a été résolu — donnez-nous votre avis !",
    "inviteCta": "Évaluer le support",
    "modalTitle": "Évaluer notre support",
    "overall": "Satisfaction globale",
    "surveyResponsiveness": "Rapidité de réponse",
    "surveyHelpfulness": "Votre problème a-t-il été résolu ?",
    "surveyProfessionalism": "Professionnalisme de l'agent",
    "cancel": "Annuler"
  },
  "realtime": {
    "tabFlash": "Mise à jour du ticket",
    "updateTitle": "Mise à jour du ticket",
    "updateBody": "Votre ticket a une nouvelle réponse."
  },
  "dispatch": {
    "title": "Transférer au vendeur / département",
    "target": {
      "vendor": "Vendeur",
      "department": "Département interne"
    },
    "department": {
      "Finance": "Finance",
      "IT": "Informatique",
      "Logistics": "Logistique",
      "Product": "Produit"
    },
    "status": {
      "Dispatched": "Transféré",
      "InProgress": "En cours",
      "Returned": "Retourné",
      "Cancelled": "Annulé"
    },
    "pickVendor": "Choisir un vendeur",
    "scopeNotePlaceholder": "Décrivez la tâche (aucune donnée personnelle du marchand pour les vendeurs)",
    "replyPlaceholder": "Répondre dans ce fil de transfert…",
    "submit": "Transférer",
    "cancel": "Annuler",
    "send": "Envoyer",
    "return": "Renvoyer au support",
    "recall": "Rappeler",
    "empty": "Aucun transfert",
    "navTitle": "File de transferts",
    "toast": {
      "created": "Transfert créé",
      "error": "Échec de l’action"
    }
  },
  "linkOrder": {
    "title": "Associer une commande",
    "searchPlaceholder": "Rechercher une commande par numéro…",
    "link": "Associer",
    "unlink": "Dissocier",
    "empty": "Aucune commande trouvée",
    "linked": "Commandes associées"
  }
}
